import { useCallback, useEffect, useState } from 'react'

import { Loading } from 'components/ui/Loading/Loading'
import {
  Cargo,
  useCargoByOrderNumber,
  useContainersActions,
} from 'services/warehouse-containers/containers'
import { ContainerItem } from 'components/ContainerItem/ContainerItem'
import { WarehouseSearch } from 'components/WarehouseSearch/WarehouseSearch'
import { Input } from 'components/ui/Input/Input'
import { Button } from 'components/ui/Button/Button'
import { Slider } from 'components/ui/Slider/Slider'
import TitledContainer from 'components/ui/TitledContainer/TitledContainer'
import { Warehouse, WarehouseType } from 'services/warehouse-containers/warehouse'

import './transfer.style.css'

export const Transfer = () => {
  const [selectedCargo, setSelectedCargo] = useState<Cargo>(null)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [targetWarehouse, setTargetWarehouse] = useState<Warehouse | null>(null)
  const [orderNumberInput, setOrderNumberInput] = useState<string>('')

  const {
    isLoading,
    setArgs,
    args: orderNumber,
    cargos,
    reset,
    refreshValues,
  } = useCargoByOrderNumber()
  const { isLoading: isActionProcessing, transferAndInspect } = useContainersActions()

  useEffect(() => () => reset(), [])

  const renderCargoItem = useCallback((el: Cargo, index: number) => {
    const handleOnSelect = (cargo: Cargo) => {
      setSelectedCargo(cargo)
      setIsActive(true)
    }

    return (
      <ContainerItem
        key={index}
        buttonText="Выполнить"
        element={el}
        onSubmut={handleOnSelect}
      ></ContainerItem>
    )
  }, [])

  const renderCargoList = useCallback(() => {
    if (isLoading || isActionProcessing) return <Loading />

    if (!orderNumber) return null

    if (!cargos?.length) {
      return <div className="support-transfer-page-empty">Грузы не найдены</div>
    }

    return <div className="support-transfer-page-list">{cargos?.map(renderCargoItem)}</div>
  }, [isLoading, isActionProcessing, orderNumber, cargos?.length, renderCargoItem])

  const renderSliderHeader = useCallback(() => {
    if (!selectedCargo) return ''

    return `#${selectedCargo?.orderNumber}`
  }, [selectedCargo])

  const handleOnSearch = useCallback(() => {
    setArgs(orderNumberInput)
  }, [orderNumberInput, setArgs])

  const handleOnSubmit = useCallback(async () => {
    if (!selectedCargo || !targetWarehouse) return

    const containerIds = selectedCargo.containers.map((el) => el.id)

    setIsActive(false)

    await transferAndInspect(targetWarehouse.id, selectedCargo.id, containerIds)

    refreshValues()
  }, [targetWarehouse, selectedCargo, refreshValues])

  const handleOnClose = () => setIsActive(false)

  return (
    <>
      <TitledContainer
        title="Перемещение + Инвентаризация"
        hint="Введите номер заказа, нажмите «Выполнить» в нужной карточке и выберите целевой склад."
      >
        <div className="support-transfer-search">
          <Input
            placeHolder="Номер заказа"
            onChange={setOrderNumberInput}
            debounce={{ duration: 0 }}
          />
          <Button
            title="Найти"
            disabled={!orderNumberInput || isLoading}
            handleOnSubmit={handleOnSearch}
          />
        </div>
      </TitledContainer>
      {renderCargoList()}
      <Slider isActive={isActive} onClose={handleOnClose} height="320px">
        <div className="transfer-page-list__slider">
          <h2>Переместить и проинвентаризировать {renderSliderHeader()}?</h2>
          <div className="support-transfer__slider-target">
            <WarehouseSearch
              title="Склад назначения"
              onSelect={setTargetWarehouse}
              searchForTypes={[WarehouseType.MiniWarehouse]}
            />
          </div>
          <div className="transfer-page-list__slider-controlls">
            <span style={{ marginRight: '0.5rem' }}>
              <Button
                title="Выполнить"
                disabled={!targetWarehouse}
                handleOnSubmit={handleOnSubmit}
              />
            </span>
            <Button outline title="Отмена" handleOnSubmit={handleOnClose} />
          </div>
        </div>
      </Slider>
    </>
  )
}
